import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { TablePagination } from "@mui/material";

import { getLanguage, deleteLanguage } from "../../store/language/language.action";
import { OPEN_LANGUAGE_DIALOG } from "../../store/language/language.type";
import { warning } from "../../util/Alert";
import TablePaginationActions from "../../util/Pagination";
import LanguageDialog from "../Dialog/LanguageDialog";

const Language = (props) => {
  const dispatch = useDispatch();
  const { languages } = useSelector((state) => state.language);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    dispatch(getLanguage());
  }, [dispatch]);

  useEffect(() => {
    setData(languages);
  }, [languages]);

  const handleChangePage = (e, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleSearch = (e) => {
    const value = e.target.value.toUpperCase();
    if (value) {
      setData(
        languages.filter(
          (lang) =>
            lang.name.toUpperCase().includes(value) ||
            lang.code.toUpperCase().includes(value)
        )
      );
    } else {
      setData(languages);
    }
  };

  const handleOpen = () => dispatch({ type: OPEN_LANGUAGE_DIALOG });
  const handleEdit = (lang) => dispatch({ type: OPEN_LANGUAGE_DIALOG, payload: lang });

  const handleDelete = (id) => {
    warning().then((isDeleted) => {
      if (isDeleted) props.deleteLanguage(id);
    });
  };

  return (
    <>
      <div className="row py-2">
        <div className="col-2">
          <h4 className="hostTitle">Language</h4>
        </div>
        <div className="col-10">
          <div className="breadcrumb-four float-right">
            <ul className="breadcrumb">
              <li>
                <Link to="/admin/dashboard">Dashboard</Link>
              </li>
              <li className="active">Language</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="row layout-top-spacing">
        <div className="col-12 layout-spacing">
          <div className="widget-content widget-content-area">
            <div className="row mb-3">
              <div className="col-8">
                <button className="btn btn-danger text-white" onClick={handleOpen}>
                  Add Language
                </button>
              </div>
              <div className="col-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Language..."
                  onChange={handleSearch}
                />
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-striped text-center">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Code</th>
                    <th>Created At</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.length > 0 ? (
                    data
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((lang, i) => (
                        <tr key={lang._id}>
                          <td>{page * rowsPerPage + i + 1}</td>
                          <td>{lang.name}</td>
                          <td>{lang.code}</td>
                          <td>{dayjs(lang.createdAt).format("DD MMM YYYY")}</td>
                          <td>
                            <button className="btn btn-info" onClick={() => handleEdit(lang)}>
                              Edit
                            </button>
                          </td>
                          <td>
                            <button className="btn btn-danger" onClick={() => handleDelete(lang._id)}>
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                  ) : (
                    <tr>
                      <td colSpan="6">No Data Found!</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, { label: "All", value: data?.length || 0 }]}
                component="div"
                count={data?.length || 0}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </div>
          </div>
        </div>
        <LanguageDialog />
      </div>
    </>
  );
};

export default connect(null, { getLanguage, deleteLanguage })(Language);
